import React from "react";
import { Link } from "react-router-dom";
import { RoutesPaths } from "../Router/Constant";

export default function Footer() {
  return (
    <>
      <div className="container-fluid maxContainerSection">
        <div className="row commonPadding">
          <div className="col-md-7 getIntouchSec">
            <h3 className="m-0 headerThree">Let's get in touch!</h3>
            <p className="m-0 peraGraph">
              Contact us for quick and friendly support with our location
              platform.
            </p>
          </div>
          <div className="col-md-5 subscribeEmailOuter">
            <div className="subscribeEmail">
              <img src="/assets/EnvelopeSimple.svg" alt="" />
              <input type="text" placeholder="Email"></input>
            </div>
            <button className="submitBtn">Submit</button>
          </div>
        </div>
      </div>

      <div className="footerCenterSection commonPadding">
        <div className="container-fluid maxContainerSection">
          <div className="row">
            <div className="col-md-12 footerCenterSectionContent">
              <img src="/assets/miaxaLogo.svg" alt="" />
              <p className="m-0 peraGraph">
                MIAXA is a location-based discovery platform that helps you find
                nearby stores, services, and local deals with ease. Explore
                what’s around you and connect with local businesses in real
                time.
              </p>
              <div className="socialIcons">
                <img src="/assets/Facebook.svg" alt="" />
                <img src="/assets/Instagram.svg" alt="" />
                <img src="/assets/LinkedIn.svg" alt="" />
                <img src="/assets/Twitter.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footerbottomSection">
        <div className="container-fluid maxContainerSection">
          <div className="row">
            <div className="col-md-12 footerbottomSectionInner">
              <p className="m-0">
                © {new Date().getFullYear()} <span>Miaxa</span> all rights
                reserved , Inc.
              </p>
              <div className="policyLinks">
                <Link to={RoutesPaths.PRIVACYPOLICY}>
                  <p className="m-0">Privacy policy</p>
                </Link>
                <Link to={RoutesPaths.TERMSCONDITIONS}>
                  <p className="m-0">Terms and conditions</p>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
